import { all, fork } from 'redux-saga/effects';

import listenListYourCar from './listenListYourCar';

export default function* listYourCarSaga() {
  yield all([fork(listenListYourCar)]);
}
